import { createFileRoute } from "@tanstack/react-router"
import { SchemaEditPage } from "@/features/schema-management/pages/SchemaEditPage"
import { z } from "zod"

export const Route = createFileRoute("/_authenticated/agent/document/schema-edit")({
    validateSearch: z.object({
        ids: z.array(z.number()).optional(),
    }),
    component: SchemaEditPage,
})
